import React from "react";
import Countdown from "react-countdown";

function ProximaLeitura() {

    // Renderer callback with condition
    const renderer = ({ minutes, seconds, completed }) => {
        if (completed) {
            // Render a complete state
            window.location.reload();
            return <Countdown date={Date.now() + 60000} renderer={renderer} />;
        } else {
            // Render a countdown
            return (
                <span>
                    {(minutes >= 10) ? minutes : "0" + minutes}:{(seconds >= 10) ? seconds : "0" + seconds}
                </span>
            );
        }
    };
    return (
        <>
            <div className="ContainerCrono">
                <p>Proxima leitura: <Countdown date={Date.now() + 60000} renderer={renderer} /></p>
            </div>
        </>
    );
}
export default ProximaLeitura;